const authHu = {
	MY_PROFILE: 'Profilom',
	LOGOUT: 'Kijelentkezés',
	LOGIN: 'Bejelentkezés',
	REGISTER: 'Regisztráció',
	EMAIL: 'E-mail',
	PASSWORD: 'Jelszó',
	PASSWORD_AGAIN: 'Jelszó megerősítése',
	LOST_YOUR_PASSWORD: 'Elfelejtette a jelszavát?',
	REQUEST_A_NEW_PASSWORD: 'Új jelszó igénylése',
	BACK_TO_LOGIN: 'Vissza a bejelentkezéshez',
	SAVE_PASSWORD: 'Jelszó mentése',
	NEW_PASSWORD_SET_MESSAGE: 'Az új jelszó sikeresen beállításra került. Kérjük, jelentkezzen be.',
	NEW_PASSWORD_SET_FAILED_MESSAGE: 'Hiba történt az új jelszó beállítása során. Kérjük, próbálja meg újra.',
	PLEASE_SET_PASSWORD_MESSAGE: 'Kérjük, adja meg az új jelszavát kétszer.',
	PLEASE_SET_EMAIL_MESSAGE: 'Kérjük, adja meg a fiókjához tartozó e-mail címet.',
	PLEASE_SET_EMAIL_DESC: 'A megadott e-mail címre jelszó-visszaállítási hivatkozást küldünk.',
	NEW_PASSWORD_REQUEST: 'E-mail küldése',
	NEW_PASSWORD_REQUEST_MESSAGE: 'A jelszó beállításához szükséges e-mailt elküldtük a megadott címre. Kérjük, ellenőrizze a postafiókját.',
	NEW_PASSWORD_REQUEST_FAILED: 'A megadott e-mail címre nem igényelhető új jelszó.'
};

export default authHu;